import { Spinner, SpinnerSize, TextField } from '@fluentui/react';
import React, { useEffect, useState, useCallback } from "react";
import Api from '../../../services/Api';
import { debounce } from 'lodash';
import { illigalCharacterValidation } from "../../CreateSite/Step2/Validation/IlligalCharactersValidation";

const validatingSpinner = <div title='Validating...' className='validation-spinner-noLabel'><Spinner size={SpinnerSize.medium} /></div>

const GroupMail = ({ mail, disabled, onChange, onValidation, isreadonly }) => {

    const [newMail, setNewMail] = useState();
    const [isValidating, setIsValidating] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const [message, setMessage] = useState();
    const [mailDomain, setMailDomain] = useState('');

    disabled = disabled || isreadonly;
    const groupMail = newMail + mailDomain;

    useEffect(() => {
        if (!disabled) {
            setIsValid(false);
            setMessage('');

            onChange('groupMail', groupMail);
            validateMail(newMail);
        }
    }, [newMail]);

    useEffect(() => {
        if (newMail) {
            onValidation('groupMail', isValid);
        }
    }, [isValid]);


    const validateMail = useCallback(
        debounce((value) => {
            if (value + mailDomain !== mail) {
                let res = illigalCharacterValidation(value, 'Mail');
                if (res.isValid) {
                    validateMailOnServer(value);
                } else {
                    setMessage(res.message);
                }
            } else {
                setIsValid(true);
            }
        }, 500), [mailDomain]);

    const validateMailOnServer = (value) => {
        const mail = encodeURIComponent(value + mailDomain);

        setIsValidating(true);

        Api.get(`/entryvalidation?groupMail=${mail}`)
            .then(res => res.data)
            .then(result => {
                setIsValidating(false);
                setIsValid(result.isValid);

                if (!result.isValid) {
                    setMessage(result.message.join('. '));
                }
            })
            .catch(error => {
                console.log(error);
            });
    }


    if (!disabled && !mailDomain) {
        const nickName = mail.replace(/@.*/gi, '');
        var nickNameRegex = new RegExp(`^${nickName}`);
        setMailDomain(mail.replace(nickNameRegex, ''));
        setNewMail(nickName);
    }

    return (
        <div style={{ display: 'flex' }}>
            <div style={{ flex: '1', display: 'flex', position: 'relative', alignItems: 'center' }}>
                {/* <div style={{ marginRight: '10px' }}>Group Mail:</div> */}
                <TextField
                    styles={{ root: { flex: '1' }, field: { marginRight: disabled ? '0' : '20px' } }}
                    onChange={(ev, value) => setNewMail(value)}
                    value={disabled ? mail : newMail}
                    errorMessage={message}
                    disabled={disabled}
                />
                {isValidating && validatingSpinner}
            </div>
            {!disabled && <div className='textField textField-disabled'>{mailDomain}</div>}
        </div>
    );
};

export default GroupMail;



// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/GroupMail.js